export const GET_ARTICLES_TAGS = "GET_ARTICLES_TAGS";
export const GET_ARTICLES_TAGS_SUCCESS = "GET_ARTICLES_TAGS_SUCCESS";
export const GET_ARTICLES_TAGS_FAIL = "GET_ARTICLES_TAGS_FAIL";
